export default __webpack_public_path__ + "static/media/machines.462a38b3.jpg";